import store from '@/store';
import Gateway from '@nsoft/seven-gravity-gateway/master';
import masterGatewayMockData from './masterGatewayMockData';

let gateway = {};

const setListeners = () => {
  gateway.on('Ticket.Changed', (message) => {
  });
};

// const sendMessage = (action, data) => {
//   gateway.sendMessage({
//     action,
//     data,
//   });
// };

const init = () => {
  /* it is necessary to have an element with id equal to slaveId/frameId which we are trying to
  communicate with, since GG master  will look for that element
  in order to listen for messages/events so for mock master to work it will be added to first child
  of app component, most likely that will be TemplateDefault component */
  document.getElementById('app').childNodes[0].setAttribute('id', window.NSoft.configuration.gameId);

  gateway = new Gateway({
    slaves: {
      [window.NSoft.configuration.gameId]: {
        frameId: window.NSoft.configuration.gameId,
        data: masterGatewayMockData,
        loaded(message) {
          // we should not fire any actions to slave until this point, right??
        },
      },
    },
    /* for dev, so that we dont have to manually add new origin every time application
    is served on different port */
    // allowedOrigins: process.env.NODE_ENV === 'development' ? [...store.getters.allowedOrigins, window.location.origin]
    // : store.getters.allowedOrigins,
    // FIXME just for testing (netlify deploy preview autogenerated domain)
    allowedOrigins: '*',
    debug: false,
  });

  setListeners();
};
export default init;
